export const THEME_PREFIX = "madden-theme";

export const POST_TYPES_TO_IGNORE = [
    "attachment",
    "nav_menu_item",
    "wp_block",
    "wp_font_family",
    "wp_font_face",
    "wp_template",
    "wp_template_part",
    "wp_navigation",
    "rm_content_editor",
    "rank_math_schema"
];
